// extracted by mini-css-extract-plugin
export default {"container":"Error_container__ILYHQ","example_text":"Error_example_text__oVZvy"};